'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  UNSUBSCRIBE_SIMPLE: null,
  ERROR_PAGE: null,
  PASSWORD_PAGE: null,
  SUBSCRIPTION_PREFERENCES: null,
  UNSUBSCRIBE_CONFIRMATION: null,
  CONTENT_SEARCH_RESULTS: null
});